<template>
  <div class="layout-wrap">
    <DefaultHeader class="exchange-header" />
    <v-content class="content-wrap">
      <v-container fluid class="pa-0">
        <AppMain />
      </v-container>
    </v-content>
  </div>
</template>
<script>
import DefaultHeader from '@/components/Header/DefaultHeader';
import AppMain from './components/AppMain';

export default {
  name: 'DefaultLayout',
  components: {
    DefaultHeader,
    AppMain
  },
  data() {
    return {};
  }
};
</script>
<style lang="stylus" scoped>
.content-wrap {
  background-color: #0e171e;
}
.exchange-header::v-deep {
  .theme--light.v-app-bar.header-wrap {
    background-color: #101521 !important;
    .burger-body {
      background-color: #101521;
    }
  }
}
</style>
